//
//
//
//
//
//
//
//
//

import Icon from '../icon'

export default {
  name: 'check-icon',
  components: {
    Icon
  },
  methods: {
    updateValue () {
      this.$emit('update:value', !this.value)
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vux@2.9.4@vux/src/components/check-icon/index.vue